import { getAll } from '@/api/admin/chats';
import {
  getExistenceByKeyValue,
  getObjectByKeyValue,
  getObjectIndexByKeyValue,
} from '@/lib/utils';

const state = {
  chats: [],
};

const getters = {};

const mutations = {
  SET_CHATS(state, { chats }) {
    const chatIds = state.chats.map(chat => chat.chatId);
    chats.forEach(chat => {
      if (chatIds.indexOf(chat.chatId) < 0) state.chats.push(chat);
    });
  },

  SET_CURRENT_CHAT_ID(state, chatId) {
    state.currentChatId = chatId;
  },

  SET_CHAT_COUNTS(state, counts) {
    Object.keys(state.counts).forEach(countKey => {
      state.counts[countKey] = counts[countKey];
    });
  },

  SET_CHAT_MODE(state, mode = '') {
    if (Object.values(state.chatModes).indexOf(mode) >= 0)
      state.chatMode = mode;
  },

  SET_REPLY_TO_MESSAGE(state, message = {}) {
    if (Object.keys(message).length > 0) {
      let chat = getObjectByKeyValue(state.chats, message.chatId, 'chatId');
      message.from = chat.from;
    }

    state.replyToMessage = message;
  },

  ADD_SELECTED_MESSAGE(state, message) {
    let messageExists = getExistenceByKeyValue(
      state.selectedMessages,
      message._id,
      '_id'
    );
    if (!messageExists) state.selectedMessages.push(message);
  },

  DELETE_FROM_SELECTED_MESSAGES(state, message) {
    let messageIndex = getObjectIndexByKeyValue(
      state.selectedMessages,
      message._id,
      '_id'
    );
    if (messageIndex >= 0) state.selectedMessages.splice(messageIndex, 1);
  },

  SET_SELECTED_MESSAGES(state, messages = []) {
    state.selectedMessages = messages;
  },
};

const actions = {
  //Api calls
  get_chats({ commit, state }, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        let chatsResponse = await getAll({
          limit: payload.limit || 20,
          skip: payload.skip || 0,
        });

        let chats = chatsResponse.data;
        let chatsWithMessages = chats.filter(chat => chat.messages.length > 0);
        let chatsWithNoMessages = chats.filter(
          chat => chat.messages.length === 0
        );

        if (chatsWithNoMessages.length)
          console.log('chatsWithNoMessages', chatsWithNoMessages);

        commit('SET_CHATS', { chats: chatsWithMessages });
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
